import Select from "react-select";
import validator from "validator";
import React, { Component } from "react";
import {Row, Col, Form} from "react-bootstrap";
import {cities, fileTypes, provinces, usageTypes} from "../../../constants";

export class SearchBox extends Component {
    constructor(props) {
        super(props);

        const province_options = Object.keys(provinces).map((id) => (
            {'value': id, 'label': provinces[id]}
        ));

        let cities_of_province = cities[this.props.searchParams.province] || {};
        const city_options = Object.keys(cities_of_province).map((id) => (
            {'value': id, 'label': cities_of_province[id]}
        ));

        const usage_type_options = Object.keys(usageTypes).map((id) => (
            {'value': id, 'label': usageTypes[id]}
        ));

        const file_type_options = Object.keys(fileTypes).map((id) => (
            {'value': id, 'label': fileTypes[id]}
        ));

        this.state = {
            selected_city: null,
            city_options,

            selected_province: null,
            province_options,

            selected_usage_type: null,
            usage_type_options,

            selected_file_type: null,
            file_type_options,
        };
    }

    componentDidMount() {
        let province = this.state.province_options.find(item => item.value == this.props.searchParams.province);
        let city = this.state.city_options.find(item => item.value == this.props.searchParams.city);
        let usage_type = this.state.usage_type_options.find(item => item.value == this.props.searchParams.usageType);
        let file_type = this.state.file_type_options.find(item => item.value == this.props.searchParams.fileType);

        this.setState({
            selected_province: province || null,
            selected_city: city || null,
            selected_usage_type: usage_type || null,
            selected_file_type: file_type || null
        });
    }

    selectRef = React.createRef();

    selectStyle = () => {
        return {
            control: (provided, state) => ({
                ...provided,
                width: "100%",
                border: 'none',
                cursor: 'pointer',
                position: 'relative',
                minWidth: '260px',
                height: '40px',
                backgroundColor: 'transparent',
                borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
                padding: '5px 0',
                transition: 'all 0.2s ease-in',
            })
        };
    };

    handleProvinceChange = option => {
        let province_id = option ? option.value : null;

        let cities_of_province = cities[province_id] || {};
        const city_options = Object.keys(cities_of_province).map((id) => (
            {'value': id, 'label': cities_of_province[id]}
        ));

        this.setState({
            selected_province: option,
            selected_city: null,
            city_options
        });

        const searchParams = {...this.props.searchParams};
        searchParams.province = province_id;
        searchParams.city = null;
        this.props.updateSearchParams(searchParams, true);
    };

    handleCityChange = option => {
        let city_id = option ? option.value : null;

        this.setState({selected_city: option});

        const searchParams = {...this.props.searchParams};
        searchParams.city = city_id;
        this.props.updateSearchParams(searchParams, true);
    };

    handleUsageTypeChange = option => {
        let usage_type_id = option ? option.value : null;

        this.setState({selected_usage_type: option});

        const searchParams = {...this.props.searchParams};
        searchParams.usageType = usage_type_id;
        this.props.updateSearchParams(searchParams, true);
    };

    handleFileTypeChange = option => {
        let file_type_id = option ? option.value : null;

        this.setState({selected_file_type: option});

        const searchParams = {...this.props.searchParams};
        searchParams.fileType = file_type_id;
        this.props.updateSearchParams(searchParams, true);
    };

    validateNumberInput = e => {
        const searchParams = {...this.props.searchParams};
        const {name, value} = e.target;

        switch (name) {
            case "min_approximate_price":
                if (this.isNum(value)) searchParams.minApproximatePrice = value;
                break;
            case "max_approximate_price":
                if (this.isNum(value)) searchParams.maxApproximatePrice = value;
                break;
            case "min_land_meter":
                if (this.isNum(value)) searchParams.minLandMeter = value;
                break;
            case "max_land_meter":
                if (this.isNum(value)) searchParams.maxLandMeter = value;
                break;
            case "min_total_meter":
                if (this.isNum(value)) searchParams.minTotalMeter = value;
                break;
            case "max_total_meter":
                if (this.isNum(value)) searchParams.maxTotalMeter = value;
                break;
            case "file_code":
                searchParams.fileCode = value;
                break;
        }

        this.props.updateSearchParams(searchParams, false);
    };

    handleBlur = e => {
        const searchParams = {...this.props.searchParams};
        this.props.updateSearchParams(searchParams, true);
    };

    isNum = value => {
        if (value == "") return true;

        return !!(
            validator.isNumeric(value, {no_symbols: true}) &&
            validator.isInt(value, {
                allow_leading_zeroes: false,
                gt: -1
            })
        );
    };

    render() {
        return (
            <div className="sidebar md-mb80">
                <div className="ml-auto">
                    <div>
                        <div className="select mb-40">
                            <Select
                                options={this.state.province_options}
                                name="provinces"
                                placeholder="استان"
                                classNamePrefix="select"
                                isRtl={true}
                                autosize={true}
                                isClearable={true}
                                isSearchable={true}
                                openMenuOnClick={true}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={true}
                                // onFocus={this.handleFocus}
                                ref={this.selectRef}
                                styles={this.selectStyle()}
                                onChange={this.handleProvinceChange}
                                value={this.state.selected_province}
                                defaultValue={this.state.selected_province}
                                noOptionsMessage={() => "موردی برای نمایش یافت نشد"}
                            />
                        </div>
                    </div>
                </div>

                <div className="ml-auto">
                    <div>
                        <div className="select mb-40">
                            <Select
                                options={this.state.city_options}
                                name="cities"
                                placeholder="شهر"
                                classNamePrefix="select"
                                isRtl={true}
                                autosize={true}
                                isClearable={true}
                                isSearchable={true}
                                openMenuOnClick={true}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={true}
                                // onFocus={this.handleFocus}
                                ref={this.selectRef}
                                styles={this.selectStyle()}
                                onChange={this.handleCityChange}
                                value={this.state.selected_city}
                                defaultValue={this.state.selected_city}
                                noOptionsMessage={() => "موردی برای نمایش یافت نشد"}
                            />
                        </div>
                    </div>
                </div>

                <div className="ml-auto">
                    <div>
                        <div className="select mb-40">
                            <Select
                                options={this.state.usage_type_options}
                                name="usage_types"
                                placeholder="کاربری"
                                classNamePrefix="select"
                                isRtl={true}
                                autosize={true}
                                isClearable={true}
                                isSearchable={true}
                                openMenuOnClick={true}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={true}
                                // onFocus={this.handleFocus}
                                styles={this.selectStyle()}
                                onChange={this.handleUsageTypeChange}
                                value={this.state.selected_usage_type}
                                defaultValue={this.state.selected_usage_type}
                                ref={this.selectRef}
                                noOptionsMessage={() => "موردی برای نمایش یافت نشد"}
                            />
                        </div>
                    </div>
                </div>

                <div className="ml-auto">
                    <div>
                        <div className="select mb-40">
                            <Select
                                options={this.state.file_type_options}
                                name="file_types"
                                placeholder="نوع"
                                classNamePrefix="select"
                                isRtl={true}
                                autosize={true}
                                isClearable={true}
                                isSearchable={true}
                                openMenuOnClick={true}
                                closeMenuOnSelect={true}
                                hideSelectedOptions={true}
                                // onFocus={this.handleFocus}
                                ref={this.selectRef}
                                styles={this.selectStyle()}
                                onChange={this.handleFileTypeChange}
                                value={this.state.selected_file_type}
                                defaultValue={this.state.selected_file_type}
                                noOptionsMessage={() => "موردی برای نمایش یافت نشد"}
                            />
                        </div>
                    </div>
                </div>

                <div className="range">
                    <Row className="mb-30">
                        <label htmlFor="">کد پرونده</label>
                        <Col md={12}>
                            <Form.Group>
                                <input
                                    name="file_code"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.fileCode}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-30">
                        <label htmlFor="">قیمت تقریبی کل</label>
                        <Col md={6}>
                            <Form.Group>
                                <input
                                    name="min_approximate_price"
                                    placeholder="حداقل"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.minApproximatePrice}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <input
                                    name="max_approximate_price"
                                    placeholder="حداکثر"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.maxApproximatePrice}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-30">
                        <label htmlFor="">مساحت عرصه</label>
                        <Col md={6}>
                            <Form.Group>
                                <input
                                    name="min_land_meter"
                                    placeholder="حداقل"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.minLandMeter}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <input
                                    name="max_land_meter"
                                    placeholder="حداکثر"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.maxLandMeter}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-30">
                        <label htmlFor="">مساحت اعیان</label>
                        <Col md={6}>
                            <Form.Group>
                                <input
                                    name="min_total_meter"
                                    placeholder="حداقل"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.minTotalMeter}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group>
                                <input
                                    name="max_total_meter"
                                    placeholder="حداکثر"
                                    onChange={this.validateNumberInput}
                                    onBlur={this.handleBlur}
                                    value={this.props.searchParams.maxTotalMeter}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}
